var _style, _circle, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6DA544;}\n\t.st1{fill:#FFDA44;}\n\t.st2{fill:#A2001D;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M393,367.3l7,14.7l15.9-3.7l-7.1,14.7l12.8,10.1l-15.9,3.6l0,16.3L393,412.8L380.3,423l0-16.3l-15.9-3.6 l12.8-10.1l-7.1-14.7L386,382L393,367.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M327.6,211.5l7,14.7l15.9-3.7l-7.1,14.7l12.8,10.1l-15.9,3.6l0,16.3l-12.7-10.2l-12.7,10.2l0-16.3l-15.9-3.6 l12.8-10.1l-7.1-14.7l15.9,3.7L327.6,211.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M393,122.4l7,14.7l15.9-3.7l-7.1,14.7l12.8,10.1l-15.9,3.6l0,16.3L393,167.9l-12.7,10.2l0-16.3l-15.9-3.6 l12.8-10.1l-7.1-14.7l15.9,3.7L393,122.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M450.1,189.2l7,14.7l15.9-3.7l-7.1,14.7l12.8,10.1l-15.9,3.6l0,16.3l-12.7-10.2l-12.7,10.2l0-16.3l-15.9-3.6 l12.8-10.1l-7.1-14.7l15.9,3.7L450.1,189.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M409.2,267.1l5.5,17h17.9l-14.5,10.5l5.5,17l-14.5-10.5l-14.5,10.5l5.5-17l-14.5-10.5h17.9L409.2,267.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M283.8,328.3c-40,0-72.3-32.4-72.3-72.3s32.4-72.3,72.3-72.3c12.5,0,24.2,3.2,34.4,8.7 c-16.1-15.7-38-25.4-62.2-25.4c-49.2,0-89,39.9-89,89s39.9,89,89,89c24.2,0,46.2-9.7,62.2-25.4C308,325.2,296.3,328.3,283.8,328.3z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M161,100.2c-7.7-13.3-22.1-22.3-38.6-22.3s-30.9,9-38.6,22.3H161z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M161.1,100.4l-38.7,38.7l-38.7-38.7c-3.7,6.5-5.8,14-5.8,22c0,24.6,19.9,44.5,44.5,44.5S167,147,167,122.4 C167,114.4,164.8,106.9,161.1,100.4L161.1,100.4z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M111.3,128v37.6c3.6,0.9,7.3,1.4,11.1,1.4s7.6-0.5,11.1-1.4V128H111.3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCc);
export default __webpack_public_path__ + "static/media/cc.30e880e40926b81299a4a5344811308d.svg";
export { ForwardRef as ReactComponent };